module.exports = __webpack_public_path__ + "static/media/Item_Back_F_00_Lv2_C.b596871e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Backpack/Item_Back_F_00_Lv2_C.png
// module id = 194
// module chunks = 0